import { useSyncExternalStore } from 'react';
import { getToken, subscribe } from 'src/services/authToken';

/**
 * The current access token; re-renders the consumer whenever it changes.
 *
 * Replaces a 200 ms `setInterval` that polled `localStorage`. Besides the
 * needless timers (the hook is instantiated more than once), polling compared
 * by value: a logout followed by a login with a byte-identical JWT inside the
 * same tick was invisible, and every consumer could be up to 200 ms behind
 * reality. Subscribing observes each transition exactly once, immediately.
 *
 * Public signature unchanged.
 */
export const useAuthToken = () => useSyncExternalStore(subscribe, getToken, getToken);
